import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";

let CampaignChargeDialogComponent = {
    selector: "vcCampaignChargeDialog",
    templateUrl:
        "/angular/components/admin/dialogs/campaign-charge-dialog.component.html",
    bindings: {
        charge: "=",
    },
    controller: class CampaignSubscriptionDialogController {
        // * bindings for typescript compiler *
        public charge: any;
        // ************************************
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        dismiss(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("admin")
    .component(
        CampaignChargeDialogComponent.selector,
        CampaignChargeDialogComponent
    );
